import { render } from "./MobileHeader.vue?vue&type=template&id=21df206e&scoped=true"
import script from "./MobileHeader.vue?vue&type=script&lang=js"
export * from "./MobileHeader.vue?vue&type=script&lang=js"

import "./MobileHeader.vue?vue&type=style&index=0&id=21df206e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21df206e"]])

export default __exports__